import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'courses/academic_calendars',
  label: 'Calendário acadêmico (cursos avulsos)',
  actions: ['list', 'create', 'edit', 'delete'],
  parentName: 'course_creation',
  onlyPermission: true
};

export default generateResources(resource);
